// Lot statuses
export var LotStatus;
(function (LotStatus) {
    LotStatus["PENDING_DEPOSITS"] = "PENDING_DEPOSITS";
    LotStatus["OPEN"] = "OPEN";
    LotStatus["FILLED"] = "FILLED";
    LotStatus["CANCELED"] = "CANCELED";
    LotStatus["EXPIRED"] = "EXPIRED";
})(LotStatus || (LotStatus = {}));
// Offer statuses
export var OfferStatus;
(function (OfferStatus) {
    OfferStatus["PENDING_DEPOSITS"] = "PENDING_DEPOSITS";
    OfferStatus["LOCKED"] = "LOCKED";
    OfferStatus["ACCEPTED"] = "ACCEPTED";
    OfferStatus["REJECTED"] = "REJECTED";
    OfferStatus["WITHDRAWN"] = "WITHDRAWN";
    OfferStatus["REFUNDED"] = "REFUNDED";
    OfferStatus["COUNTERED"] = "COUNTERED";
    OfferStatus["EXPIRED"] = "EXPIRED";
})(OfferStatus || (OfferStatus = {}));
//# sourceMappingURL=types.js.map